import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Workflow from '../components/Workflow';
import Services from '../components/Services';
import Industries from '../components/Industries';
import Technologies from '../components/Technologies';
import TestimonialsAndStats from '../components/TestimonialsAndStats';
import Hiring from '../components/Hiring';
import PortfolioTeaser from '../components/PortfolioTeaser';
import ClientLogos from '../components/ClientLogos';
import TrustBadges from '../components/TrustBadges';
import FAQ from '../components/FAQ';
import AboutTeaser from '../components/AboutTeaser';

const Home = () => {
  useEffect(() => {
    document.title = "Businex – Innovative IT Solutions & Expert Case Studies";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Businex is a tech consulting firm delivering AI, Cloud, Mobile, and Data solutions. Explore our portfolio of case studies and contact us for custom software development.");
    }
  }, []);
  return (
    <div className="">
      <Hero />
      <ClientLogos />
      <AboutTeaser />
      <Workflow />
      <Services />
      <PortfolioTeaser />
      <TestimonialsAndStats />
      <TrustBadges />
      <Industries />
      <Hiring />
      <Technologies />
      <FAQ />
    </div>
  );
};

export default Home;
